export const arrow_down_right = () => (
  <path
    d="M7 7l10 10m0 0V7m0 10H7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
